import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import App from './App.jsx';
import AdminRoutes from './appRoutes/admin/AdminRoutes';
import BrokerRoutesV2 from './appRoutes/broker/BrokerRoutesV2.js';
import { NotFound } from './common/SharedComponents';
import BasePathRouting from './appRoutes/components/BasePathRouting';
import {
    UnifiedLoginPage,
    UnifiedForgotPasswordPage,
    UnifiedPasswordResetPage,
    UnifiedReferralsPage,
    UnifiedSettingsPage,
    loginCssLoader,
    referralsCssLoader,
    settingsCssLoader,
} from './appRoutes/appRoutes';

export const router = createBrowserRouter(
    createRoutesFromElements(
        <Route
            path='/'
            element={<App />}
        >
            {/* Admin-specific routes: wrapped in OldAdminScss with CSS loader */}
            {AdminRoutes()}

            {/* Broker V1 routes: /brokeraccount, /broker/signagreement */}
            {BrokerRoutesV2()}

            {/* Unified routes — previously duplicated across V1/V2 route sets */}
            <Route
                path='/login'
                loader={loginCssLoader}
                element={<UnifiedLoginPage />}
            />
            <Route
                path='/forgotPassword'
                loader={loginCssLoader}
                element={<UnifiedForgotPasswordPage />}
            />
            <Route
                path='/resetPassword'
                loader={loginCssLoader}
                element={<UnifiedPasswordResetPage />}
            />
            <Route
                path='/referrals'
                loader={referralsCssLoader}
                element={<UnifiedReferralsPage />}
            />
            <Route
                path='/settings'
                loader={settingsCssLoader}
                element={<UnifiedSettingsPage />}
            />
            <Route
                path='/'
                element={<BasePathRouting />}
            />
            <Route
                path='*'
                element={<NotFound />}
            />
        </Route>
    )
);
